import { track } from "@/features/analytics";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@components/ui/dropdown-menu";
import Tooltip from "@components/ui/tooltip";
import { cn } from "@lib/cn";
import { IconHeadset, IconHelp } from "@tabler/icons-react";
import { useCallback, useState } from "react";

const HELP_CENTER_URL = "https://help.storydoc.com/en/";
const HELP_ITEM_ICON_CLASS = "tw-fill-none tw-text-[#12033E]";

export const HelpNavMenu = () => {
  const [open, setOpen] = useState(false);

  const handleContactSupport = useCallback(() => {
    track("click contact support");
    window.Intercom?.("show");
  }, []);

  const handleHelpCenter = useCallback(() => {
    track("click help center");
    window.open(HELP_CENTER_URL, "_blank");
  }, []);

  const handleOpenChange = useCallback((next: boolean) => {
    setOpen(next);
    if (next) {
      track("open help menu");
      window.Intercom?.("hide");
    }
  }, []);

  return (
    <DropdownMenu open={open} onOpenChange={handleOpenChange}>
      <Tooltip placement="bottom">
        <Tooltip.Trigger asChild>
          <DropdownMenuTrigger
            type="button"
            aria-label="Help"
            className={cn(
              "tw-flex tw-size-8 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-lg tw-border-none tw-bg-transparent tw-text-blue tw-outline-none tw-transition-colors hover:tw-bg-blue-50 [&_svg]:tw-fill-none [&_svg]:tw-stroke-current",
              open && "tw-bg-blue-50",
            )}
          >
            <IconHelp className="tw-text-blue-700" />
          </DropdownMenuTrigger>
        </Tooltip.Trigger>
        <Tooltip.Content>
          <Tooltip.Text>Help</Tooltip.Text>
        </Tooltip.Content>
      </Tooltip>
      <DropdownMenuContent
        side="bottom"
        align="end"
        sideOffset={8}
        className="tw-w-[176px] tw-origin-top tw-animate-dropdown-scale-in"
      >
        <div className="tw-px-1">
          <DropdownMenuItem onSelect={handleContactSupport}>
            <IconHeadset
              size={20}
              stroke={1.5}
              className={HELP_ITEM_ICON_CLASS}
            />
            Contact support
          </DropdownMenuItem>
          <DropdownMenuItem onSelect={handleHelpCenter}>
            <IconHelp size={20} stroke={1.5} className={HELP_ITEM_ICON_CLASS} />
            Help center
          </DropdownMenuItem>
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
